/**
 * ,<{
            url: "/campaigns-check-hearings",
            title: "hearings",
        }
 */
export default[
    {
        "url": "/home",
        logo: 'img/menu/home.png',
        logo_active: 'img/menu/home_active.png',
        title: "dashboard"
    },{
        "url": "/reviews",
        logo: 'img/menu/reviews.png',
        logo_active: 'img/menu/reviews_active.png',
        title: "reviews"
    },{
        "url": "/plan",
        logo: 'img/menu/plan.png',
        logo_active: 'img/menu/plan_active.png',
        title: "plan"
    },{
        url: "/campaigns-check",
        logo: 'img/menu/marketing.png',
        logo_active: 'img/menu/marketing_active.png',
        title: "marketing",
        plan: "PLUS",
        submenu:[{
            url: "/campaigns-check-normal",
            title: "campaigns",
            submenu:[{
                url: "/campaigns-check-normal-hearings",
                title: "hearings",
            }]
        },{
            url: "/campaigns-check-flow",
            title: "flow",
            ShopOrTNOrIDs: "tn-2686675|tn-2572438|tn-4998152|tn-6103959|tn-2686675",
            text: "withAI",
        }]
    },{
        url: "/chatbot",
        logo: 'img/menu/chatbot.png',
        logo_active: 'img/menu/chatbot_active.png',
        title: "Chatbot IA",
        ids: "60770517158|68661543101",
        submenu:[{
            url: "/chatbot-config",
            title: "Configuración",
        },{
            url: "/chatbot-training",
            title: "Entrenamiento",
        }]
    },{
        url: "/messages",
        logo: 'img/menu/inbox.png',
        logo_active: 'img/menu/inbox_active.png',
        title: "Mensajes",
        moduleConfig: "INBOX",
        //"61253681305|69691965690|8988636|8945744|60770517158|68661543101|tn-4010714|91951661329|75458937116|64618856632|27461288034|61098098839|57045778512|69348294908|66779414728"
    },{
        url: "/Notifications",
        logo: 'img/menu/notificacion.png',
        logo_active: 'img/menu/notificacion_active.png',
        title: "notifications",
        plan: "PLUS",
    },{
        "url": "/analytics",
        logo: 'img/menu/analytics.png',
        logo_active: 'img/menu/analytics_active.png',
        title: "analytic",
        submenu:[{
            "url": "/analytics-products",
            title: "products",
        }]
    },{
        "url": "/config",
        logo: 'img/menu/config.png',
        logo_active: 'img/menu/config_active.png',
        title: "configuracion",
        submenu:[{
            "url": "/config-whatsapp",
            title: "confg_whatsapp",
           // ids: "55229055169,67535372503,68790321402,68432953636,64999260391,8222801997,50185404600,64314114245"
           //planType: "PLUS"
           variableTrue: "enabledCampaigns"
        }]
    },{
        "url": "/frequentquestions",
        logo: 'img/menu/freq.png',
        logo_active: 'img/menu/freq_active.png',
        title: "frequentquestions"
    }
    ];
    